import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const settingsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = settingsAdapter.getInitialState()

export const settingsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getSettings: builder.query({
            query: () => ({
                url: '/settings',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedSettings = responseData.map(setting => {
                    setting.id = setting._id
                    return setting
                });
                return settingsAdapter.setAll(initialState, loadedSettings)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Setting', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Setting', id }))
                    ]
                } else return [{ type: 'Setting', id: 'LIST' }]
            }
        }),
        addNewSetting: builder.mutation({
            query: initialSetting => ({
                url: '/settings',
                method: 'POST',
                body: {
                    ...initialSetting,
                }
            }),
            invalidatesTags: [
                { type: 'Setting', id: "LIST" }
            ]
        }),
        updateSetting: builder.mutation({
            query: initialSetting => ({
                url: '/settings',
                method: 'PATCH',
                body: {
                    ...initialSetting,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Setting', id: arg.id }
            ]
        }),
        deleteSetting: builder.mutation({
            query: ({ id }) => ({
                url: `/settings`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Setting', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetSettingsQuery,
    useAddNewSettingMutation,
    useUpdateSettingMutation,
    useDeleteSettingMutation,
} = settingsApiSlice

// returns the query result object
export const selectSettingsResult = settingsApiSlice.endpoints.getSettings.select()

// creates memoized selector
const selectSettingsData = createSelector(
    selectSettingsResult,
    settingsResult => settingsResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllSettings,
    selectById: selectSettingById,
    selectIds: selectSettingIds
    // Pass in a selector that returns the settings slice of state
} = settingsAdapter.getSelectors(state => selectSettingsData(state) ?? initialState)